import React, { useState } from 'react';
import { GridComponent, ColumnsDirective, ColumnDirective, Inject, Page, Toolbar } from '@syncfusion/ej2-react-grids';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { Modal, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

export const ItensMaintenances = () => {
  const dispatch = useDispatch();
  dispatch({ type: "title", value: "Cadastro de itens" });

  const [itens, setItens] = useState([
    { id: 1, item: "item1" },
    { id: 2, item: "item2" },
    { id: 3, item: "item3" },
    { id: 4, item: "item4" }
  ]);
  const [newItem, setNewItem] = useState("");
  const [editId, setEditId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const handleSave = () => {
    if (newItem.trim() !== "") {
      if (editId) {
        setItens(itens.map((item) => (item.id === editId ? { ...item, item: newItem } : item)));
        setEditId(null);
      } else {
        setItens([...itens, { id: itens.length + 1, item: newItem }]);
      }
      setNewItem("");
    }
  };

  const handleClear = () => {
    setNewItem("");
    setEditId(null);
  };

  const handleEdit = (id) => {
    const itemToEdit = itens.find((item) => item.id === id);
    if (itemToEdit) {
      setNewItem(itemToEdit.item);
      setEditId(id);
    }
  };

  const handleDelete = () => {
    setItens(itens.filter((item) => item.id !== deleteId));
    setShowModal(false);
    setDeleteId(null);
  };

  const actionTemplateEdit = (props) => (
    <button
      className="btn btn-link p-0"
      style={{ color: "var(--text-primary)" }}
      onClick={() => handleEdit(props.id)}
    >
      <FaEdit size={18} />
    </button>
  );

  const actionTemplateDelete = (props) => (
    <button
      className="btn btn-link p-0"
      style={{ color: "var(--text-primary)" }}
      onClick={() => {
        setDeleteId(props.id);
        setShowModal(true);
      }}
    >
      <FaTrash size={18} />
    </button>
  );

  return (
    <div className='ml-4'>
      <p>Adicione o item que deseja ter controle de uso</p>
      <div className="filter-maintenance">
        <input
          type="text"
          value={newItem}
          onChange={(e) => setNewItem(e.target.value)}
          placeholder="Digite o nome do item"
          className="form-control"
        />
        <button onClick={handleSave} className="btn btn-primary me-2">
          {editId ? "Atualizar" : "Salvar"}
        </button>
        <button onClick={handleClear} className="btn btn-secondary">
          Limpar
        </button>
      </div>

      {/* GridComponent para exibir os itens */}
      <div className="card mt-4">
        <GridComponent
          dataSource={itens}
          allowPaging={true}
          pageSettings={{ pageSize: 5 }}
        >
          <ColumnsDirective>
            <ColumnDirective field="item" headerText="Item" width="200" />
            <ColumnDirective
              headerText="Editar"
              width="100"
              textAlign="Center"
              template={actionTemplateEdit}
            />
            <ColumnDirective
              headerText="Excluir"
              width="100"
              textAlign="Center"
              template={actionTemplateDelete}
            />
          </ColumnsDirective>
          <Inject services={[Page, Toolbar]} />
        </GridComponent>
      </div>

      {/* Modal de confirmação para exclusão */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmação</Modal.Title>
        </Modal.Header>
        <Modal.Body>Deseja realmente excluir este item?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
